export default {
	history: {
		saveInFile: "Сохранить в файл",
		server: "Сервер:",
		lastHistory: "Последняя история",
		historyFilesList: "Список файлов истории",
		noCronOnCurrentServer: "На текущем сервере нет cron-а",
	},
	scheduler: {
		schedulerStructure: "Структура расписания",
		cronHelp: "Помощь по CRON",
		schedulerConsistOfPackeges: "Расписание состоит из пакетов, которые запланированы запускаться в определенное время.",
		eachPackageConsistsOfAnArbitraryNumber: "Каждый пакет состоит из произвольного количества шагов.",
		stepIsATemplateThatWorksWithSpecificTasks: "Шаг является шаблоном, который работает с задачами конкретного приложения.",
		stepCreate: "Создание шага",
		forStepCreateNeedSelectApp: "Для создания шага необходимо выбрать приложение.",
		AfterThatListOfTemplatesCreatedForThisWillAppear: "После этого появится список шаблонов, которые созданы для этого приложения.",
		ifNeededSelectBaseYouNeedSelectItFromCurrentList: "Если в задаче требуется указать базу, ее нужно будет выбрать из последующего списка баз приложения.",
		stepEdit: "Редактирование шага",
		stepEditError: "Нельзя редактировать базы созданного шага, но можно удалить конкретный и на его месте создать новый шаг.",
		stepsCanBeRearranged: "Шаги можно переставлять местами и добавлять/удалять с любого места пакета путем соответствующих кнопок.",
		stepsEditWarning: "Если один из шагов пакета был создан из шаблона, который потом был изменен, напротив этого пакета в целом и шага в частности будет соответствующая запись.",
		packageCanHaveOneSchedule: "Пакет может иметь одно расписание, которое можно выставить на специальной форме.",
		packagesCanBeSortedByNameOrDate: "Пакеты можно сортировать по их названию или по часу их запуска в расписании.",
		newChanges: "Новые изменения",
		version: "версия",
		nowYouCanCreateTasksCopy: "Появилась возможность создавать копии задач при создании / редактировании шага на основании шаблона.",
		allBasesAndQuanityAdded: "Справа от задачи находятся два новых элемента: кнопка 'все базы' и поле 'кол-во'.",
		allBasesElementCanCreateAllCopiesOfTasks: "'Все базы' создаст столько копий задачи, сколько в приложении баз и автоматически привяжет все копии соответствующим базам. Видна только в том случае, если задаче необходимо ввести базу.",
		quanityElementCreateCopiesOfCurrentTask: "'Кол-во' создаст копии текущей задачи введенное количество раз (существующая задача учитывается при создании).",
		cronExportPreview: "Превью экспорта CRON",
		cancel: "Отменить",
		export: "Экспорт",
		server: "Сервер:",
		cronCreate: "Создать CRON",
		cronExport: "Экспорт CRON",
		cronEdit: "Редактирование CRON",
		templatesEdit: "Редактирование шаблонов",
		onCurrentServerCronNotFound: "На данном сервере не найден CRON.",
		cronNotExported: "CRON не экспортирован"
	}
};
